import { Api } from "./Api";
import { Option } from "../models/Option";

export class ListParamApi extends Api {
    constructor() {
        super("app/params");
    }

    getAll(params?: Object): Promise<Array<Option>> {
        return this.getResources(params).then(function (response) {
            let res: Array<Option> = [];
            if (response.data && response.data.data) {
                res = response.data.data;
            }
            return res;
        });
    }
}
